(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[624],{

/***/ 4624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ app_content_AppContent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js + 3 modules
var row = __webpack_require__(6402);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js + 1 modules
var col = __webpack_require__(6226);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 45 modules
var modal = __webpack_require__(2542);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/app-content/app-footer/AppFooter.module.scss
var AppFooter_module = __webpack_require__(224);
var AppFooter_module_default = /*#__PURE__*/__webpack_require__.n(AppFooter_module);
;// CONCATENATED MODULE: ./src/components/app-content/app-footer/AppFooter.tsx


var AppFooter = function(param) {
    var Title = param.Title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (AppFooter_module_default()).title,
        children: Title
    });
};
/* harmony default export */ var app_footer_AppFooter = (AppFooter);

// EXTERNAL MODULE: ./src/components/app-content/app-footnote/AppFootnote.module.scss
var AppFootnote_module = __webpack_require__(980);
var AppFootnote_module_default = /*#__PURE__*/__webpack_require__.n(AppFootnote_module);
;// CONCATENATED MODULE: ./src/components/app-content/app-footnote/AppFootnote.tsx


var AppFootnote = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (AppFootnote_module_default()).container,
        children: [
            content.FootnoteTitle.value && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: (AppFootnote_module_default()).title,
                children: content.FootnoteTitle.value
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (AppFootnote_module_default()).content,
                dangerouslySetInnerHTML: {
                    __html: content.FootnoteContent.value
                }
            })
        ]
    });
};
/* harmony default export */ var app_footnote_AppFootnote = (AppFootnote);

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5440);
// EXTERNAL MODULE: ./src/components/app-content/app-gameFormat/AppGameFormat.module.scss
var AppGameFormat_module = __webpack_require__(5845);
var AppGameFormat_module_default = /*#__PURE__*/__webpack_require__.n(AppGameFormat_module);
;// CONCATENATED MODULE: ./public/images/icon_football.svg
var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconFootball = function SvgIconFootball(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "".concat(props.prefix || "", "icon_football_svg__a")
  }, _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M11 0c6.073.006 10.994 4.927 11 11 0 6.075-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0Zm-.52 16.86L7.885 18.8l.515.987.303.085a9.06 9.06 0 0 0 6.456-.719l.282-.152-.72-1.876-4.24-.265Zm-6.256.259a9.198 9.198 0 0 0 3.088 2.285l-.35-.594-2.607-1.897H4.05Zm7.56-8.684-2.586 3.508 1.198 3.476a.392.392 0 0 0 .35.276l3.942.55a.424.424 0 0 0 .381-.18l1.993-3.37-1.58-3.804-3.698-.456Zm-9.537-.053a9.251 9.251 0 0 0-.403 2.671 9.135 9.135 0 0 0 1.452 4.928h.127a.127.127 0 0 0 .095-.096l.53-3.804a.329.329 0 0 0 0-.201L2.882 8.7a.403.403 0 0 0-.381-.265h-.254ZM17.41 5.733a.403.403 0 0 0-.434.286l-.88 2.777a.53.53 0 0 0 0 .286l1.442 3.38c.054.118.16.204.286.234l2.034.519A8.997 8.997 0 0 0 20.145 11a9.114 9.114 0 0 0-1.547-5.108ZM5.945 4.59a.434.434 0 0 0-.37.19l-2.12 3.233a.424.424 0 0 0 .063.392l1.293 2.819a.434.434 0 0 0 .34.243l3.327.318a.382.382 0 0 0 .37-.159l2.322-3.232a.445.445 0 0 0 0-.413L9.792 4.99a.392.392 0 0 0-.35-.233Zm7.63-2.321.127.392 3.328 2.5 1.06.096v-.02a9.167 9.167 0 0 0-4.515-2.968Zm-2.617-.424a9.04 9.04 0 0 0-5.373 1.77.276.276 0 0 0 .074.148c.17.085 3.74.159 4.324.159a.434.434 0 0 0 .17 0l2.51-1.134a.424.424 0 0 0 .234-.445v-.286a9.283 9.283 0 0 0-1.94-.212Z"
  }))), /*#__PURE__*/react.createElement("clipPath", {
    id: "".concat(props.prefix || "", "icon_football_svg__b")
  }, _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M24 0v24H0V0h24Z"
  })))), /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#".concat(props.prefix || "", "icon_football_svg__a)")
  }, _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#204193",
    d: "M0 0h22v22H0V0z"
  })), /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#".concat(props.prefix || "", "icon_football_svg__b)"),
    transform: "translate(-1 -1)"
  }, _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#00C06C",
    d: "M1 1h22v22H1V1z"
  })))));
};
/* harmony default export */ var icon_football = (SvgIconFootball);
;// CONCATENATED MODULE: ./public/images/icon_football_example.svg
var icon_football_example_path, icon_football_example_path2, icon_football_example_path3, icon_football_example_path4;
function icon_football_example_extends() { icon_football_example_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_football_example_extends.apply(this, arguments); }

var SvgIconFootballExample = function SvgIconFootballExample(props) {
  return /*#__PURE__*/react.createElement("svg", icon_football_example_extends({
    width: 20,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "".concat(props.prefix || "", "icon_football_example_svg__a")
  }, icon_football_example_path || (icon_football_example_path = /*#__PURE__*/react.createElement("path", {
    d: "M13.334 0c.79 0 1.43.639 1.43 1.427v9.031l1.357-1.319a.95.95 0 0 1 1.334 0l2.271 2.274a.931.931 0 0 1 0 1.32l-9.018 8.999a.96.96 0 0 1-.667.268H7.759a.938.938 0 0 1-.947-.933v-2.35h-5.38a1.423 1.423 0 0 1-1.012-.41A1.414 1.414 0 0 1 0 17.302V1.427C-.003 1.047.147.683.416.415A1.423 1.423 0 0 1 1.431 0h11.903Zm3.411 11.123-8.082 8.045v.944h.947l8.082-8.045-.947-.944Zm-3.863-9.246H1.916l-.022 15.017h6.457l4.53-4.559V1.877Zm-9.084 5.69.12.006h4.928a.945.945 0 0 1 .846.938.945.945 0 0 1-.846.939H3.917a.948.948 0 0 1-.903-.438.941.941 0 0 1 .666-1.435l.118-.01Zm.129-3.282.12.006h5.65a.945.945 0 0 1 .845.938.945.945 0 0 1-.846.939h-5.65a.948.948 0 0 1-.903-.438.941.941 0 0 1 .666-1.435l.118-.01Z"
  }))), /*#__PURE__*/react.createElement("clipPath", {
    id: "".concat(props.prefix || "", "icon_football_example_svg__b")
  }, icon_football_example_path2 || (icon_football_example_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M25.828 0v25.743H0V0h25.828Z"
  })))), /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#".concat(props.prefix || "", "icon_football_example_svg__a)")
  }, icon_football_example_path3 || (icon_football_example_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#204193",
    d: "M0 0h20v22H0V0z"
  })), /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#".concat(props.prefix || "", "icon_football_example_svg__b)"),
    transform: "translate(-3.228 -2.145)"
  }, icon_football_example_path4 || (icon_football_example_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#00C06C",
    d: "M3.228 2.145h20v22h-20v-22z"
  })))));
};
/* harmony default export */ var icon_football_example = (SvgIconFootballExample);
// EXTERNAL MODULE: ./node_modules/antd/es/collapse/index.js + 6 modules
var collapse = __webpack_require__(4907);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/UpOutlined.js + 1 modules
var UpOutlined = __webpack_require__(8115);
;// CONCATENATED MODULE: ./src/components/app-content/app-gameFormat/AppGameFormat.tsx










var Panel = collapse/* default.Panel */.Z.Panel;
var AppGameFormat = function(param) {
    var content = param.content;
    var ref, ref1, ref2, ref3;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref4 = (0,react.useState)(false), gameFormateCollapsed = ref4[0], setGameFormateCollapsed = ref4[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (AppGameFormat_module_default())["game-content"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (AppGameFormat_module_default())["game-format-name"],
                    dangerouslySetInnerHTML: {
                        __html: content.GameFormatName.value
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(collapse/* default */.Z, {
                    className: classnames_default()({
                        panelOpend: !gameFormateCollapsed
                    }, "table-collapse"),
                    expandIcon: function(param) {
                        var isActive = param.isActive;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UpOutlined/* default */.Z, {
                            rotate: isActive ? 180 : 0
                        });
                    },
                    expandIconPosition: "end",
                    defaultActiveKey: [
                        "0"
                    ],
                    ghost: true,
                    onChange: function() {
                        return setGameFormateCollapsed(!gameFormateCollapsed);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Panel, {
                        header: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (AppGameFormat_module_default())["title-content"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (AppGameFormat_module_default()).icon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_football, {
                                        prefix: content.key
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (AppGameFormat_module_default())["text-title"],
                                    children: t("GameFormate")
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((AppGameFormat_module_default()).GameFormatContent, content === null || content === void 0 ? void 0 : (ref = content.styleclass) === null || ref === void 0 ? void 0 : ref.value),
                                    dangerouslySetInnerHTML: {
                                        __html: content.GameFormatContent.value
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (AppGameFormat_module_default()).GameFormatFootnote,
                                    dangerouslySetInnerHTML: {
                                        __html: content.GameFormatFootnote.value
                                    }
                                }),
                                (content === null || content === void 0 ? void 0 : (ref1 = content.ExampleContent) === null || ref1 === void 0 ? void 0 : ref1.value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (AppGameFormat_module_default())["example-container"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (AppGameFormat_module_default())["title-content"],
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (AppGameFormat_module_default()).icon,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_football_example, {
                                                        prefix: content.key
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (AppGameFormat_module_default())["text-title"],
                                                    children: t("Example")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()((AppGameFormat_module_default()).ExampleContent, content === null || content === void 0 ? void 0 : (ref2 = content.styleclass) === null || ref2 === void 0 ? void 0 : ref2.value),
                                            dangerouslySetInnerHTML: {
                                                __html: content.ExampleContent.value
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (AppGameFormat_module_default()).ExampleFootnote,
                                            dangerouslySetInnerHTML: {
                                                __html: content.ExampleFootnote.value
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }, "0")
                }),
                (content === null || content === void 0 ? void 0 : (ref3 = content.OverallFootnote) === null || ref3 === void 0 ? void 0 : ref3.value) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (AppGameFormat_module_default()).OverallFootnote,
                    dangerouslySetInnerHTML: {
                        __html: content.OverallFootnote.value
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var app_gameFormat_AppGameFormat = (AppGameFormat);

// EXTERNAL MODULE: ./src/components/app-content/app-header/AppHeader.module.scss
var AppHeader_module = __webpack_require__(493);
var AppHeader_module_default = /*#__PURE__*/__webpack_require__.n(AppHeader_module);
;// CONCATENATED MODULE: ./src/components/app-content/app-header/AppHeader.tsx



var AppHeader = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
        className: classnames_default()((AppHeader_module_default()).title, "hidden md:block"),
        children: content.Header.value
    });
};
/* harmony default export */ var app_header_AppHeader = (AppHeader);

// EXTERNAL MODULE: ./src/components/app-content/app-image/AppImage.module.scss
var AppImage_module = __webpack_require__(3976);
var AppImage_module_default = /*#__PURE__*/__webpack_require__.n(AppImage_module);
;// CONCATENATED MODULE: ./src/components/app-content/app-image/AppImage.tsx



var AppImage = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (AppImage_module_default())["image-content"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-wrap",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md-:w-1/2 w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "w-full",
                        src: content.Image.src,
                        alt: content.ImageTitle.value
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    className: "md-:w-1/2 w-full text-justify",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: content.ImageTextContent.value
                        }
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var app_image_AppImage = (AppImage);

// EXTERNAL MODULE: ./src/components/app-content/app-paragraphs/AppParagraphs.module.scss
var AppParagraphs_module = __webpack_require__(4367);
var AppParagraphs_module_default = /*#__PURE__*/__webpack_require__.n(AppParagraphs_module);
;// CONCATENATED MODULE: ./src/components/app-content/app-paragraphs/AppParagraphs.tsx



var AppParagraphs = function(param) {
    var content = param.content, routerPath = param.routerPath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((AppParagraphs_module_default()).paragraphs, (AppParagraphs_module_default())[routerPath[routerPath.length - 1]]),
        dangerouslySetInnerHTML: {
            __html: content.ContentParagraphs.rendered
        }
    });
};
/* harmony default export */ var app_paragraphs_AppParagraphs = (AppParagraphs);

// EXTERNAL MODULE: ./src/components/app-content/app-refundDetails/AppRefundDetails.module.scss
var AppRefundDetails_module = __webpack_require__(459);
var AppRefundDetails_module_default = /*#__PURE__*/__webpack_require__.n(AppRefundDetails_module);
;// CONCATENATED MODULE: ./src/components/app-content/app-refundDetails/AppRefundDetails.tsx









var AppRefundDetails_Panel = collapse/* default.Panel */.Z.Panel;
var AppRefundDetails = function(param) {
    var content = param.content;
    var ref, ref1;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref2 = (0,react.useState)(false), collapsed = ref2[0], setCollapsed = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (AppRefundDetails_module_default()).content,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(collapse/* default */.Z, {
            className: classnames_default()({
                panelOpend: !collapsed
            }),
            expandIcon: function(param) {
                var isActive = param.isActive;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(UpOutlined/* default */.Z, {
                    rotate: isActive ? 180 : 0
                });
            },
            expandIconPosition: "end",
            defaultActiveKey: [
                "0"
            ],
            ghost: true,
            onChange: function() {
                return setCollapsed(!collapsed);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppRefundDetails_Panel, {
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (AppRefundDetails_module_default()).title,
                    children: t("RefundDetails")
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: content.content.value
                            }
                        }),
                        (content === null || content === void 0 ? void 0 : (ref = content.ExampleContent) === null || ref === void 0 ? void 0 : ref.value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (AppRefundDetails_module_default())["example-container"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (AppRefundDetails_module_default())["title-content"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (AppRefundDetails_module_default()).icon,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_football_example, {
                                                prefix: content.key
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (AppRefundDetails_module_default())["text-title"],
                                            children: t("Example")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((AppRefundDetails_module_default()).ExampleContent, content === null || content === void 0 ? void 0 : (ref1 = content.styleclass) === null || ref1 === void 0 ? void 0 : ref1.value),
                                    dangerouslySetInnerHTML: {
                                        __html: content.ExampleContent.value
                                    }
                                })
                            ]
                        })
                    ]
                })
            }, "0")
        })
    });
};
/* harmony default export */ var app_refundDetails_AppRefundDetails = (AppRefundDetails);

// EXTERNAL MODULE: ./src/components/app-content/app-table/AppTable.module.scss
var AppTable_module = __webpack_require__(339);
var AppTable_module_default = /*#__PURE__*/__webpack_require__.n(AppTable_module);
;// CONCATENATED MODULE: ./src/components/app-content/app-table/AppTable.tsx






var AppTable_Panel = collapse/* default.Panel */.Z.Panel;
var AppTable = function(param) {
    var content = param.content;
    var ref, ref1, ref2;
    var styleclass = (ref = content.styleclass) === null || ref === void 0 ? void 0 : ref.value;
    var ref3 = (0,react.useState)(false), collapsed = ref3[0], setCollapsed = ref3[1];
    var tbl = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (AppTable_module_default())["table-container"],
                dangerouslySetInnerHTML: {
                    __html: content.tableHtml.value
                }
            }),
            (content === null || content === void 0 ? void 0 : (ref1 = content.tableFooter) === null || ref1 === void 0 ? void 0 : ref1.value) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((AppTable_module_default())["table-footer"], "px-3 md:px-0"),
                dangerouslySetInnerHTML: {
                    __html: content.tableFooter.value
                }
            })
        ]
    });
    if (styleclass.includes("accordion")) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (AppTable_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(collapse/* default */.Z, {
                    className: classnames_default()({
                        panelOpend: !collapsed
                    }, "table-collapse"),
                    expandIcon: function(param) {
                        var isActive = param.isActive;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UpOutlined/* default */.Z, {
                            rotate: isActive ? 0 : 180
                        });
                    },
                    expandIconPosition: "end",
                    defaultActiveKey: [
                        "0"
                    ],
                    ghost: true,
                    onChange: function() {
                        return setCollapsed(!collapsed);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppTable_Panel, {
                        header: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "'px-3 md:px-0'",
                            children: content.tableHeader.value
                        }),
                        children: tbl
                    }, "0")
                }),
                collapsed && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (AppTable_module_default()).split
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (content === null || content === void 0 ? void 0 : (ref2 = content.tableHeader) === null || ref2 === void 0 ? void 0 : ref2.value) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((AppTable_module_default())["table-header"], "px-3 md:px-0"),
                dangerouslySetInnerHTML: {
                    __html: content.tableHeader.value
                }
            }),
            tbl
        ]
    });
};
/* harmony default export */ var app_table_AppTable = (AppTable);

// EXTERNAL MODULE: ./src/components/app-content/app-title/AppTitle.tsx + 1 modules
var AppTitle = __webpack_require__(8990);
// EXTERNAL MODULE: ./src/common/models/app-language.ts
var app_language = __webpack_require__(8790);
// EXTERNAL MODULE: ./src/components/app-content/app-video-pop/AppVideoPop.module.scss
var AppVideoPop_module = __webpack_require__(2729);
var AppVideoPop_module_default = /*#__PURE__*/__webpack_require__.n(AppVideoPop_module);
;// CONCATENATED MODULE: ./src/components/app-content/app-video-pop/AppVideoPop.tsx






var AppVideoPop = function(param) {
    var content = param.content, videoLink = param.videoLink, videoPoster = param.videoPoster, _isPopup = param.isPopup, isPopup = _isPopup === void 0 ? false : _isPopup, _videoAutoPlay = param.videoAutoPlay, videoAutoPlay = _videoAutoPlay === void 0 ? false : _videoAutoPlay;
    var i18n = (0,esm/* useTranslation */.$G)().i18n;
    var ref = (0,react.useState)(""), videoSrc = ref[0], setVideoSrc = ref[1];
    (0,react.useEffect)(function() {
        var ref;
        var lan = i18n.language === app_language/* AppLanguage.zh_hk */.u.zh_hk ? "cht" : "eng";
        var link = content ? content.VideoURL.value : videoLink;
        var poster = content ? content.VideoPoster.src : videoPoster;
        var autostart = (content === null || content === void 0 ? void 0 : (ref = content.VideoAutoPlay) === null || ref === void 0 ? void 0 : ref.value) || videoAutoPlay;
        if (!(poster === null || poster === void 0 ? void 0 : poster.startsWith("http"))) {
            poster = "".concat(location.origin).concat(poster);
        }
        var rf = location.href;
        setVideoSrc("https://common.hkjc.com/videoplayer_v3/video-player-iframe_v3.aspx?rf=".concat(rf, "&videourl=").concat(link, "&bgcolor=ffffff&ismultiangle=false&lang=").concat(lan, "&autostart=").concat(autostart, "&qualitybtn=true&posterimage=").concat(poster, "&themecolor=D9AD00"));
    }, [
        content,
        i18n.language,
        videoAutoPlay,
        videoLink,
        videoPoster
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (AppVideoPop_module_default()).container,
        children: [
            content && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (AppVideoPop_module_default()).title,
                children: content.VideoTitle.value
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((AppVideoPop_module_default())["video-container"], !isPopup && (AppVideoPop_module_default())["out-pop"]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    width: "100%",
                    height: "auto",
                    className: (AppVideoPop_module_default())["iframe-container"],
                    allowFullScreen: true,
                    src: videoSrc
                })
            })
        ]
    });
};
/* harmony default export */ var app_video_pop_AppVideoPop = (AppVideoPop);

// EXTERNAL MODULE: ./src/components/app-content/AppContent.module.scss
var AppContent_module = __webpack_require__(1632);
var AppContent_module_default = /*#__PURE__*/__webpack_require__.n(AppContent_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/common/pathConvert.ts + 1 modules
var pathConvert = __webpack_require__(7507);
// EXTERNAL MODULE: ./src/components/app-content/app-ticket-filling/AppTicketFilling.module.scss
var AppTicketFilling_module = __webpack_require__(5380);
var AppTicketFilling_module_default = /*#__PURE__*/__webpack_require__.n(AppTicketFilling_module);
;// CONCATENATED MODULE: ./src/components/app-content/app-ticket-filling/AppTicketFilling.tsx






function AppTicketFilling(param) {
    var content = param.content;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,esm/* useTranslation */.$G)(), 1), t = ref7[0];
    var iconIndex = 0;
    var icons = [
        "a.gif",
        "b.gif",
        "c.gif",
        "d.gif",
        "e.gif",
        "f.gif",
        "g.gif",
        "h.gif",
        "i.png"
    ];
    var ticketLegends = content === null || content === void 0 ? void 0 : (ref = content.ticketLegends) === null || ref === void 0 ? void 0 : (ref1 = ref.targetItems) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, index) {
        var ref, ref1;
        var iconPath = "";
        if ((item === null || item === void 0 ? void 0 : (ref = item.legendIconEnabled) === null || ref === void 0 ? void 0 : ref.value) === "1") {
            var ref2;
            iconPath = item === null || item === void 0 ? void 0 : (ref2 = item.legendIcon) === null || ref2 === void 0 ? void 0 : ref2.src;
        } else {
            if (iconIndex < icons.length) {
                iconPath = (0,pathConvert/* withBasePath */.w)("/images/ticket-legends/icon_".concat(icons[iconIndex++]));
            }
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex py-1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    width: 15,
                    height: 15,
                    src: iconPath,
                    alt: ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "pl-3",
                    children: item === null || item === void 0 ? void 0 : (ref1 = item.legendName) === null || ref1 === void 0 ? void 0 : ref1.value
                })
            ]
        }, index);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (AppTicketFilling_module_default())["ticket-filling"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "marksix-sub-title",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        id: content === null || content === void 0 ? void 0 : content.name
                    }),
                    content === null || content === void 0 ? void 0 : (ref2 = content.ticketTypeName) === null || ref2 === void 0 ? void 0 : ref2.value
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-wrap",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-wrap w-full py-3 pl-5 sm:pl-20 md-:pl-8 md:pl-8 lg:pl-10 xl:pl-20 2xl:pl-40",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-start w-full md-:w-1/2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "underline",
                                            children: t("TicketFilling")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "max-w-full",
                                            src: content === null || content === void 0 ? void 0 : (ref3 = content.ticketFillingImage) === null || ref3 === void 0 ? void 0 : ref3.src,
                                            alt: ""
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-xs max-w-full items-start w-full md-:hidden ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (AppTicketFilling_module_default())["filling-detail"],
                                        dangerouslySetInnerHTML: {
                                            __html: content === null || content === void 0 ? void 0 : (ref4 = content.ticketTypeContent) === null || ref4 === void 0 ? void 0 : ref4.value
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col items-start w-full mt-5 md-:mt-0 md-:w-1/2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "underline",
                                        children: t("TicketValidation")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "max-w-full pt-2",
                                        src: content === null || content === void 0 ? void 0 : (ref5 = content.ticketValidationImage) === null || ref5 === void 0 ? void 0 : ref5.src,
                                        alt: ""
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-xs max-w-full items-start w-1/2 hidden md-:flex ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (AppTicketFilling_module_default())["filling-detail"],
                                dangerouslySetInnerHTML: {
                                    __html: content === null || content === void 0 ? void 0 : (ref6 = content.ticketTypeContent) === null || ref6 === void 0 ? void 0 : ref6.value
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col items-start text-xs w-full md-:w-1/2 md-:flex ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: ticketLegends
                            })
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/LeftCircleFilled.js + 1 modules
var LeftCircleFilled = __webpack_require__(9190);
// EXTERNAL MODULE: ./node_modules/antd/es/carousel/index.js + 9 modules
var carousel = __webpack_require__(1980);
// EXTERNAL MODULE: ./src/components/app-content/app-slider/AppSlider.module.scss
var AppSlider_module = __webpack_require__(8368);
var AppSlider_module_default = /*#__PURE__*/__webpack_require__.n(AppSlider_module);
;// CONCATENATED MODULE: ./src/components/app-content/app-slider/AppSlider.tsx








function SliderArrowLeft(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: props.onClick,
        className: classnames_default()(props.className, {
            "rotate-180": props.rotate180
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftCircleFilled/* default */.Z, {
            className: "arrow",
            rotate: props.rotate180 ? 180 : 0
        })
    });
}
function AppSlider(param) {
    var content = param.content;
    var ref;
    var sliders = (0,react.useMemo)(function() {
        return content === null || content === void 0 ? void 0 : content.slides.filter(function(sl) {
            var ref;
            return (sl === null || sl === void 0 ? void 0 : (ref = sl.slideEnabled) === null || ref === void 0 ? void 0 : ref.value) === "1";
        });
    }, [
        content === null || content === void 0 ? void 0 : content.slides
    ]);
    var renderedSliders = (0,react.useMemo)(function() {
        return sliders === null || sliders === void 0 ? void 0 : sliders.map(function(item, ind) {
            var ref, ref1;
            var imgPath = (ref = item.slideImage) === null || ref === void 0 ? void 0 : ref.src;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "w-full",
                        src: imgPath,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full",
                        dangerouslySetInnerHTML: {
                            __html: (ref1 = item.slideImageCaption) === null || ref1 === void 0 ? void 0 : ref1.value
                        }
                    })
                ]
            }, ind);
        });
    }, [
        sliders
    ]);
    var slideProps = {
        infinite: false,
        arrows: true,
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderArrowLeft, {}),
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderArrowLeft, {
            rotate180: true
        }),
        appendDots: function(dots) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: dots
            });
        },
        customPaging: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (AppSlider_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-3",
                dangerouslySetInnerHTML: {
                    __html: (content === null || content === void 0 ? void 0 : (ref = content.sliderHeader) === null || ref === void 0 ? void 0 : ref.value) || ""
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("px-9 md:px-28 pb-6", (AppSlider_module_default())["sliders-container"]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, slideProps), {
                    children: renderedSliders
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
        ]
    });
}
/* harmony default export */ var app_slider_AppSlider = (/*#__PURE__*/(0,react.memo)(AppSlider));

// EXTERNAL MODULE: ./src/components/app-content/app-payout-time/AppPayoutTime.module.scss
var AppPayoutTime_module = __webpack_require__(7740);
var AppPayoutTime_module_default = /*#__PURE__*/__webpack_require__.n(AppPayoutTime_module);
;// CONCATENATED MODULE: ./src/components/app-content/app-payout-time/AppPayoutTime.tsx



var AppPayoutTime = function(param) {
    var routerPath = param.routerPath, content = param.content;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((AppPayoutTime_module_default()).container),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (AppPayoutTime_module_default()).notice,
                dangerouslySetInnerHTML: {
                    __html: content === null || content === void 0 ? void 0 : (ref = content.NoticeMessage) === null || ref === void 0 ? void 0 : ref.value
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                className: (AppPayoutTime_module_default())["tournament-info"],
                children: content.tournamentInfo.targetItems.map(function(t, n) {
                    var ref, ref1, ref2, ref3, ref4, ref5;
                    return (t === null || t === void 0 ? void 0 : (ref = t.tournamentName) === null || ref === void 0 ? void 0 : ref.value) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                        sm: 12,
                        md: 6,
                        children: [
                            (t === null || t === void 0 ? void 0 : (ref1 = t.tournamentIcon) === null || ref1 === void 0 ? void 0 : ref1.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: t === null || t === void 0 ? void 0 : (ref2 = t.tournamentIcon) === null || ref2 === void 0 ? void 0 : ref2.src,
                                alt: t === null || t === void 0 ? void 0 : (ref3 = t.tournamentName) === null || ref3 === void 0 ? void 0 : ref3.value
                            }),
                            t === null || t === void 0 ? void 0 : (ref4 = t.tournamentName) === null || ref4 === void 0 ? void 0 : ref4.value
                        ]
                    }, (t === null || t === void 0 ? void 0 : (ref5 = t.tournamentCode) === null || ref5 === void 0 ? void 0 : ref5.value) || n) : "";
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (AppPayoutTime_module_default()).remarks,
                dangerouslySetInnerHTML: {
                    __html: content === null || content === void 0 ? void 0 : (ref1 = content.Remarks) === null || ref1 === void 0 ? void 0 : ref1.value
                }
            })
        ]
    });
};
/* harmony default export */ var app_payout_time_AppPayoutTime = (AppPayoutTime);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
;// CONCATENATED MODULE: ./src/util.ts

var isServer = (/* unused pure expression or super */ null && ("object" === "undefined"));
var isStandAlonePage = function(name) {
    return (0,lodash.toLower)(name) === "info";
};

// EXTERNAL MODULE: ./src/components/app-content/app-match-info/AppMatchInfo.module.scss
var AppMatchInfo_module = __webpack_require__(6282);
var AppMatchInfo_module_default = /*#__PURE__*/__webpack_require__.n(AppMatchInfo_module);
;// CONCATENATED MODULE: ./src/components/app-content/app-match-info/AppMatchInfo.tsx







var AppMatchInfo_Panel = collapse/* default.Panel */.Z.Panel;
var AppMatchInfo = function(param) {
    var routerPath = param.routerPath, content = param.content;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)({
        Leagues: true,
        Cups: true,
        Internationals: true,
        Others: true
    }), collapsed = ref[0], setCollapsed = ref[1];
    var targenItems = function(targets) {
        var name = targets.name;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(collapse/* default */.Z, {
                className: classnames_default()({
                    panelOpend: !collapsed[name]
                }, (AppMatchInfo_module_default())["match-info-collapse"]),
                expandIcon: function(param) {
                    var isActive = param.isActive;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UpOutlined/* default */.Z, {
                        rotate: isActive ? 0 : 180
                    });
                },
                expandIconPosition: "end",
                defaultActiveKey: [
                    name
                ],
                ghost: true,
                onChange: function() {
                    return setCollapsed(Object.assign(collapsed, {
                        name: !collapsed[name]
                    }));
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMatchInfo_Panel, {
                    header: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (AppMatchInfo_module_default())["title-content"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (AppMatchInfo_module_default())["text-title"],
                            children: t("MatchInfo.".concat(name))
                        })
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                        className: (AppMatchInfo_module_default())["tournament-info"],
                        gutter: 16,
                        children: targets.targetItems.map(function(t, n) {
                            var ref, ref1, ref2, ref3, ref4, ref5;
                            return (t === null || t === void 0 ? void 0 : (ref = t.tournamentName) === null || ref === void 0 ? void 0 : ref.value) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                className: (AppMatchInfo_module_default()).item,
                                sm: 12,
                                md: 6,
                                xs: 12,
                                children: [
                                    (t === null || t === void 0 ? void 0 : (ref1 = t.tournamentIcon) === null || ref1 === void 0 ? void 0 : ref1.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: t === null || t === void 0 ? void 0 : (ref2 = t.tournamentIcon) === null || ref2 === void 0 ? void 0 : ref2.src,
                                        alt: t === null || t === void 0 ? void 0 : (ref3 = t.tournamentName) === null || ref3 === void 0 ? void 0 : ref3.value
                                    }),
                                    t === null || t === void 0 ? void 0 : (ref4 = t.tournamentName) === null || ref4 === void 0 ? void 0 : ref4.value
                                ]
                            }, (t === null || t === void 0 ? void 0 : (ref5 = t.tournamentCode) === null || ref5 === void 0 ? void 0 : ref5.value) || n) : "";
                        })
                    })
                }, name)
            })
        });
    };
    var ItemEnabled = function(enabled) {
        return (enabled === null || enabled === void 0 ? void 0 : enabled.value) === "1";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((AppMatchInfo_module_default()).container),
        children: [
            ItemEnabled(content.leaguesEnabled) && targenItems(content.leagues),
            ItemEnabled(content.cupsEnabled) && targenItems(content.cups),
            ItemEnabled(content.internationalsEnabled) && targenItems(content.internationals),
            ItemEnabled(content.othersEnabled) && targenItems(content.others)
        ]
    });
};
/* harmony default export */ var app_match_info_AppMatchInfo = (AppMatchInfo);

// EXTERNAL MODULE: ./src/components/app-content/app-important-matters/AppImportantMatters.module.scss
var AppImportantMatters_module = __webpack_require__(8941);
var AppImportantMatters_module_default = /*#__PURE__*/__webpack_require__.n(AppImportantMatters_module);
;// CONCATENATED MODULE: ./src/components/app-content/app-important-matters/AppImportantMatters.tsx







var AppImportantMatters_Panel = collapse/* default.Panel */.Z.Panel;
var AppImportantMatters = function(param) {
    var content = param.content;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), collapsed = ref[0], setCollapsed = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (AppImportantMatters_module_default()).content,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(collapse/* default */.Z, {
            className: classnames_default()({
                panelOpend: !collapsed
            }),
            expandIcon: function(param) {
                var isActive = param.isActive;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(UpOutlined/* default */.Z, {
                    rotate: isActive ? 180 : 0
                });
            },
            expandIconPosition: "end",
            defaultActiveKey: [
                "0"
            ],
            ghost: true,
            onChange: function() {
                return setCollapsed(!collapsed);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImportantMatters_Panel, {
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (AppImportantMatters_module_default()).title,
                    children: content.ImportantMatterName.value
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: content.ImportantMatterContent.value
                    }
                })
            }, "0")
        })
    });
};
/* harmony default export */ var app_important_matters_AppImportantMatters = (AppImportantMatters);

;// CONCATENATED MODULE: ./src/components/app-content/AppContent.tsx





















var components = {
    PageGenericHeader: app_header_AppHeader,
    PageGenericContentParagraphs: app_paragraphs_AppParagraphs,
    PageGenericTable: app_table_AppTable,
    PageGenericImage: app_image_AppImage,
    PageGenericFooter: app_footer_AppFooter,
    PageGenericFootnote: app_footnote_AppFootnote,
    GameFormat: app_gameFormat_AppGameFormat,
    RefundDetails: app_refundDetails_AppRefundDetails,
    PageGenericVideo: app_video_pop_AppVideoPop,
    MarksixTicketType: AppTicketFilling,
    PageGenericSlider: app_slider_AppSlider,
    PayoutTime: app_payout_time_AppPayoutTime,
    LeagueNTournament: app_match_info_AppMatchInfo,
    ImportantMatters: app_important_matters_AppImportantMatters
};
var AppContent = function(param) {
    var pageData = param.pageData, title = param.title, routerPath = param.routerPath, description = param.description;
    var ref;
    var pageContent = pageData === null || pageData === void 0 ? void 0 : (ref = pageData.Content) === null || ref === void 0 ? void 0 : ref.data;
    var withoutEnabeld = [
        "PageGenericHeader",
        "Expample",
        "GameFormat",
        "RefundDetails",
        "PayoutTime",
        "LeagueNTournament",
        "ImportantMatters", 
    ];
    var ref1 = (0,react.useState)(false), isModalOpen = ref1[0], setIsModalOpen = ref1[1];
    var ref2 = (0,react.useState)(null), videoLink = ref2[0], setVideoLink = ref2[1];
    var ref3 = (0,react.useState)(null), videoPoster = ref3[0], setVideoPoster = ref3[1];
    var ref4 = (0,react.useState)(null), modalTitle = ref4[0], setModalTitle = ref4[1];
    var ref5 = (0,react.useState)(null), modalDescription = ref5[0], setModalDescription = ref5[1];
    var ref6 = (0,react.useState)(false), videoAutoPlay = ref6[0], setVideoAutoPlay = ref6[1];
    var showModal = function() {
        setIsModalOpen(true);
    };
    var footNote = pageContent.find(function(c) {
        var ref;
        var temName = (c === null || c === void 0 ? void 0 : (ref = c.template) === null || ref === void 0 ? void 0 : ref.name) || c.__typename;
        return temName === "PageGenericFootnote";
    });
    console.log(footNote);
    var handleCancel = function() {
        setIsModalOpen(false);
        setVideoLink(null);
        setVideoPoster(null);
    };
    var handleVideoPop = (0,react.useCallback)(function(event) {
        var ref, ref1;
        var dataLink = event.currentTarget.attributes.getNamedItem("data-link").value;
        var dataPoster = event.currentTarget.attributes.getNamedItem("data-poster").value;
        var dataTitle = ((ref = event.currentTarget.attributes.getNamedItem("data-title")) === null || ref === void 0 ? void 0 : ref.value) || "";
        var dataDesc = ((ref1 = event.currentTarget.attributes.getNamedItem("data-description")) === null || ref1 === void 0 ? void 0 : ref1.value) || "";
        var dataAutoPlay = event.currentTarget.attributes.getNamedItem("data-autoplay").value || false;
        setVideoLink(dataLink);
        setVideoPoster(dataPoster);
        setModalTitle(dataTitle);
        setModalDescription(dataDesc);
        setVideoAutoPlay(dataAutoPlay);
        showModal();
    }, []);
    var handleHoverImg = (0,react.useCallback)(function(event) {
        var imgPath = event.currentTarget.attributes.getNamedItem("hoversrc").value;
        event.currentTarget.attributes.src.value = imgPath;
        event.currentTarget.removeEventListener("mouseover", handleHoverImg);
    }, []);
    (0,react.useEffect)(function() {
        var ref = document.querySelectorAll(".demo-video-pop");
        ref.forEach(function(item) {
            item.addEventListener("click", handleVideoPop, false);
        });
        return function() {
            ref.forEach(function(item) {
                item.removeEventListener("click", handleVideoPop);
            });
        };
    }, [
        handleVideoPop,
        pageContent
    ]);
    (0,react.useEffect)(function() {
        var ref = document.querySelectorAll(".hoverImg");
        ref.forEach(function(item) {
            item.addEventListener("mouseover", handleHoverImg, false);
        });
    }, [
        handleHoverImg,
        pageContent
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((AppContent_module_default()).container, isStandAlonePage(routerPath[0]) && (AppContent_module_default())["info-container"], "bg-white mb-[10px]"),
                style: {
                    boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.05)"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                xs: isStandAlonePage(routerPath[0]) ? 24 : 0,
                                md: 24,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppTitle/* default */.Z, {
                                    Title: title,
                                    routerPath: routerPath
                                })
                            }),
                            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                dangerouslySetInnerHTML: {
                                    __html: description
                                },
                                className: (AppContent_module_default()).description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((AppContent_module_default())["page-content"], "flex flex-wrap py-3 md:py-6"),
                        children: pageContent.map(function(c, cIndex) {
                            var ref, ref1, ref2;
                            var temName = (c === null || c === void 0 ? void 0 : (ref = c.template) === null || ref === void 0 ? void 0 : ref.name) || c.__typename;
                            var Tag = components[temName];
                            var enabled = (withoutEnabeld.includes(temName) || (c === null || c === void 0 ? void 0 : (ref1 = c.enabled) === null || ref1 === void 0 ? void 0 : ref1.value) === "1") && temName !== "PageGenericFootnote";
                            var itemPadding = classnames_default()("md:px-6", "px-3");
                            return enabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()(temName, (AppContent_module_default())["content-container"], "w-full", "overflow-hidden", itemPadding, ((ref2 = c.styleclass) === null || ref2 === void 0 ? void 0 : ref2.value) || "", c.key),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                                    content: c,
                                    routerPath: routerPath
                                })
                            }, temName + cIndex) : "";
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (AppContent_module_default())["modal-title"],
                                    children: modalTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (AppContent_module_default())["modal-desc"],
                                    children: modalDescription
                                })
                            ]
                        }),
                        open: isModalOpen,
                        onCancel: handleCancel,
                        footer: null,
                        width: "60%",
                        className: (AppContent_module_default())["modal-container"],
                        destroyOnClose: true,
                        children: videoLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(app_video_pop_AppVideoPop, {
                            videoPoster: videoPoster,
                            videoLink: videoLink,
                            isPopup: true,
                            videoAutoPlay: videoAutoPlay
                        })
                    })
                ]
            }),
            footNote && /*#__PURE__*/ (0,jsx_runtime.jsx)(app_footnote_AppFootnote, {
                content: footNote
            })
        ]
    });
};
/* harmony default export */ var app_content_AppContent = (AppContent);


/***/ }),

/***/ 8990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ app_title_AppTitle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./src/components/app-content/app-title/AppTitle.module.scss
var AppTitle_module = __webpack_require__(8351);
var AppTitle_module_default = /*#__PURE__*/__webpack_require__.n(AppTitle_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./public/images/print.svg
var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "".concat(props.prefix || "", "print_svg__a")
  }, _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M15.526 0c1.05 0 1.902.864 1.902 1.93v3.519a.53.53 0 0 1 0 .133h1.203c.9 0 1.76.365 2.393 1.012.633.648.984 1.525.976 2.436v3.992c-.006.978-.786 1.77-1.75 1.775h-2.802v3.766A1.436 1.436 0 0 1 16.022 20H5.978c-.784 0-1.42-.642-1.426-1.437v-3.807H1.75C.786 14.751.006 13.96 0 12.981V8.989c.006-1.883 1.512-3.407 3.368-3.407h1.153V1.93C4.521.864 5.373 0 6.423 0h9.103Zm.152 12.006H6.322v6.157h9.356v-6.157Zm2.953-4.648H3.368a1.61 1.61 0 0 0-1.598 1.61v3.992h2.782v-2.79h12.896v2.79l2.782-.02V8.969a1.61 1.61 0 0 0-1.599-1.611Zm-.12.841c.373 0 .677.308.677.688 0 .38-.304.687-.678.687a.683.683 0 0 1-.678-.687c0-.38.304-.688.678-.688Zm-2.954-6.403H6.453a.132.132 0 0 0-.131.133v3.52c0 .074.059.133.131.133h9.104c.072 0 .131-.06.131-.133v-3.52a.132.132 0 0 0-.131-.133Z"
  }))), /*#__PURE__*/react.createElement("clipPath", {
    id: "".concat(props.prefix || "", "print_svg__b")
  }, _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M24 0v24H0V0h24Z"
  })))), /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#".concat(props.prefix || "", "print_svg__a)"),
    transform: "translate(1 2)"
  }, _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v20H0V0z"
  })), /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#".concat(props.prefix || "", "print_svg__b)"),
    transform: "translate(-1 -2)"
  }, _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M1 2h22v20H1V2z"
  })))));
};
/* harmony default export */ var print = (SvgPrint);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5440);
;// CONCATENATED MODULE: ./src/components/app-content/app-title/AppTitle.tsx





var AppTitle = function(param) {
    var Title = param.Title, routerPath = param.routerPath;
    var t = (0,esm/* useTranslation */.$G)().t;
    var betTypeStyle = (AppTitle_module_default())[(0,lodash.toLower)(routerPath[1])] || "";
    var infoStyle = (0,lodash.toLower)(routerPath[0]) === "info" ? (AppTitle_module_default())[(0,lodash.toLower)(routerPath[0])] : "";
    var showPrint = [
        "selling-hours"
    ].includes(routerPath[routerPath.length - 1]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((AppTitle_module_default()).title, " ").concat(betTypeStyle, " ").concat(infoStyle, " ").concat((AppTitle_module_default())[routerPath[routerPath.length - 1]]),
        children: [
            Title,
            showPrint && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (AppTitle_module_default()).print,
                onClick: function() {
                    try {
                        window.print();
                    } catch (e) {
                        console.log(e);
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(print, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("Print")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var app_title_AppTitle = (AppTitle);


/***/ }),

/***/ 1632:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"AppContent_container__kr73e","description":"AppContent_description__dg9VG","page-content":"AppContent_page-content__5KJ8s","content-container":"AppContent_content-container__bmlO5","info-container":"AppContent_info-container__wNsHi","modal-container":"AppContent_modal-container__9RyuQ","modal-title":"AppContent_modal-title__W5S7_","modal-desc":"AppContent_modal-desc__1RPGh"};

/***/ }),

/***/ 224:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"AppFooter_title__mLC2J","racing":"AppFooter_racing__tHj2D","football":"AppFooter_football__6QPok"};

/***/ }),

/***/ 980:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"AppFootnote_container__wmA9J","title":"AppFootnote_title__XEOoG","content":"AppFootnote_content__s_XDj"};

/***/ }),

/***/ 5845:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"game-content":"AppGameFormat_game-content__dqs73","game-format-name":"AppGameFormat_game-format-name__DJk34","title-content":"AppGameFormat_title-content__XrBwP","text-title":"AppGameFormat_text-title__KMeTZ","example-container":"AppGameFormat_example-container__varRh","ExampleFootnote":"AppGameFormat_ExampleFootnote___JFDU","OverallFootnote":"AppGameFormat_OverallFootnote__bGudw"};

/***/ }),

/***/ 493:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"AppHeader_title__yg6ew"};

/***/ }),

/***/ 3976:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 8941:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"AppImportantMatters_content__i7_DL","title":"AppImportantMatters_title__W8u55"};

/***/ }),

/***/ 6282:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"AppMatchInfo_container__WbEQf","match-info-collapse":"AppMatchInfo_match-info-collapse__KC_pC","tournament-info":"AppMatchInfo_tournament-info__J6L8d","item":"AppMatchInfo_item__4ovAm"};

/***/ }),

/***/ 4367:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"paragraphs":"AppParagraphs_paragraphs____EfG","selling-hours":"AppParagraphs_selling-hours__9FmBQ"};

/***/ }),

/***/ 7740:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"AppPayoutTime_container___Yfo5","notice":"AppPayoutTime_notice__6qgxM","tournament-info":"AppPayoutTime_tournament-info__0YXwM","remarks":"AppPayoutTime_remarks__knNCq"};

/***/ }),

/***/ 459:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"AppRefundDetails_content__w4Rrh","title":"AppRefundDetails_title__xnt4P","example-container":"AppRefundDetails_example-container__9ucFu","title-content":"AppRefundDetails_title-content__NW71Y","text-title":"AppRefundDetails_text-title___h_WO"};

/***/ }),

/***/ 8368:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"AppSlider_container___zCFX"};

/***/ }),

/***/ 339:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"table-header":"AppTable_table-header__CE_W6","table-container":"AppTable_table-container__WcM2D","container":"AppTable_container__1cuFb","split":"AppTable_split__5vEJf"};

/***/ }),

/***/ 5380:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ticket-filling":"AppTicketFilling_ticket-filling__fNWOQ","filling-detail":"AppTicketFilling_filling-detail__IlNk6"};

/***/ }),

/***/ 8351:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"AppTitle_title__v29lb","racing":"AppTitle_racing__2sxjA","football":"AppTitle_football__peh_Y","marksix":"AppTitle_marksix__Cjj1F","print":"AppTitle_print__ogwEH","match-info":"AppTitle_match-info__C7I7R","info":"AppTitle_info__SdhGn"};

/***/ }),

/***/ 2729:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"AppVideoPop_container__5rZlZ","title":"AppVideoPop_title__flnY1","video-container":"AppVideoPop_video-container__bpaeg","out-pop":"AppVideoPop_out-pop__VBHVl","iframe-container":"AppVideoPop_iframe-container__uJMJv"};

/***/ })

}]);